import { EChartsOption } from 'echarts';
import { dataViewFormatter, getTimestampedFileNameForWidget } from '../helpers/widgets';

interface PestCountData {
  [name: string]: {
    pestCount: number;
    mostCommon: string;
  };
}

const getPestCountChartConfig = (data: PestCountData): EChartsOption => {
  const children = Object.entries(data).map(([name, details]) => ({
    name,
    value: details.pestCount,
    mostCommon: details.mostCommon,
  }));

  return {
    color: [
      '#f26b4b', // Orange
      '#0582bf', // Dark blue
      '#8c7ebb', // Light purple
      '#00a7ca', // Mid teal
      '#473b7b', // Dark purple
      '#66c39b', // Mid green
      '#82afdd', // Mid cornflower
      '#c83c7b', // Dark magenta
      '#86cdae', // Light green
      '#007093', // Dark teal
      '#a8ceee', // Light cornflower
      '#26312b', // Charcoal
      '#00916f', // Dark green
      '#615097', // Mid purple
      '#00b1d8', // Light blue
      '#5fc9de', // Light teal
      '#ee4891', // Mid magenta
      '#6894cd', // Dark cornflower
      '#0395ca', // Mid blue
    ],
    title: {
      show: false,
    },
    legend: {
      show: false, // Completely hides the legend
    },
    toolbox: {
      feature: {
        dataView: {
          show: true,
          readOnly: true,
          optionToContent: (option: any): string | HTMLElement => dataViewFormatter(option as EChartsOption),
        },
        saveAsImage: {
          show: true,
          name: getTimestampedFileNameForWidget('rongo-pest-count'),
        },
      },
    },
    tooltip: {
      formatter: function (info: any) {
        const { name, value, data } = info;
        return `
          <strong>${name}</strong><br/>
          ${data.mostCommon || 'N/A'}
        `;
      },
    },
    series: [
      {
        name: 'Pest Data',
        type: 'treemap',
        data: children,
        top: 25,
        bottom: 10,
        left: 25,
        right: 25,
        roam: false,
        breadcrumb: {
          show: false,
        },
        label: {
          show: true,
          formatter: function (params: any) {
            return `{nameStyle|${params.name}}\n{countStyle|${params.value}}`;
          },
          rich: {
            nameStyle: {
              align: 'center',
              verticalAlign: 'top',
              fontSize: 12,
              fontWeight: 'bold',
              color: '#fff',
              padding: [0, 0, 10, 0],
            },
            countStyle: {
              align: 'center',
              verticalAlign: 'middle',
              fontSize: 18,
              fontWeight: 'bold',
              color: '#fff',
            },
          },
        },
        labelLayout: (params) => ({
          y: params.labelRect.y,
          align: 'center',
        }),
        levels: [
          {
            itemStyle: {
              borderWidth: 4,
              gapWidth: 4,
            },
          },
        ],
      },
    ],
  };
};

export { getPestCountChartConfig, PestCountData };
